<ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
  <ziro-custom-select [fieldId]="'usage_location'"></ziro-custom-select>
  <ziro-read-write-select-config [fieldId]="'licenses'" [type]="type"></ziro-read-write-select-config>
</ziro-collapsible-section-card>
